import { LCBatchesPresentationOrderEnum } from '../../compat/tvpil';
import { LastWatched } from '../../lastWatched';
import { Channel, ChannelAsset } from '../types';

import { sortChannels } from './sortChannels';
import { tryCreateChannel } from './utils';

type ComposeFavoriteLineupArgs = {
  channelAssetsMap: Map<number, ChannelAsset>;
  channelCollection: number[];
  entitledChannels: Set<number>;
  favoriteChannels: Map<number, number>;
  lastWatched: LastWatched | undefined;
  mostWatched: Map<number, number>;
  orderBatches?: LCBatchesPresentationOrderEnum[];
};

export function composeFavoriteLineup({
  channelAssetsMap,
  channelCollection,
  entitledChannels,
  favoriteChannels,
  lastWatched,
  mostWatched,
  orderBatches,
}: ComposeFavoriteLineupArgs) {
  const channels: Array<Channel> = [];

  for (let i = 0; i < channelCollection.length; i++) {
    const channel = tryCreateChannel({ channelAssetsMap, entitledChannels, id: channelCollection[i] });

    if (!channel) {
      continue;
    }

    channel.isFavorite = favoriteChannels.has(channel.id);

    // if last watched channel exist on collection it must be first
    if (lastWatched?.channelId === channel.id) {
      continue;
    }

    channels.push(channel);
  }

  const sorted = orderBatches
    ? sortChannels(channels, {
        orderBatches: orderBatches,
        favoriteChannels,
        mostWatchedChannels: mostWatched,
      })
    : channels;

  if (lastWatched) {
    const lastWatchedChannel = tryCreateChannel({ channelAssetsMap, entitledChannels, id: lastWatched.channelId });

    if (lastWatchedChannel) {
      lastWatchedChannel.isFavorite = favoriteChannels.has(lastWatchedChannel.id);

      sorted.unshift(lastWatchedChannel);
    }
  }

  return sorted;
}
